import { ref, push } from 'firebase/database';
import { database } from './firebaseconfig';

export const USER_ID_KEY = 'squareComputersUserId';

// Appends one entry to user_info/{userId}/track — used to log which tabs/products a visitor viewed.
export const trackVisit = (type, label) => {
  const userId = sessionStorage.getItem(USER_ID_KEY);
  if (!userId || !label) return;
  push(ref(database, `user_info/${userId}/track`), {
    type,
    label,
    timestamp: new Date().toISOString(),
  }).catch(() => {});
};
